<template>
	<div>
		<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent" ref="groupkpiTable" ></vxe-grid>
		<add-index :nodeid="nodeid" ref="addspukpiIndex" @modalhide="addHide" />
		<importTable :ref="importRef" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import addIndex from './add/index.vue'
	import importTable from '@_system/components/import/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			nodeid: {
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				importRef: Math.random(),
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
				this.$refs[this.importRef].importcomfig = () => {
					return Promise.resolve([{
						title: '商品编码',
						require: true
					},{
						title: 'kpi',
						require: true
					},{
						title: '时间',
						require: true
					}])
				}
				this.$refs[this.importRef].importApi = () => {
					let data = this.$refs[this.importRef].importGetTableData()
					let goods = data.map((item) => {
						return {
							groupid:this.nodeid,
							type:'spu',
							kpi:item['kpi'],
							itemid: item['商品编码'],
							date: item['时间'],
						}
					})
					console.log(goods)
					this.$api.BIshopgoods.uploadgroupkpi({
						data: goods
					}).then(() => {
						this.$refs[this.importRef].importNoticeShow = false
						this.$refs.groupkpiTable.commitProxy('query')
						this.$message.success('操作成功')
					})
				}
		},
		methods: {
			importgoodskpi() {
				this.$refs[this.importRef].importpanel()
			},
			
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 450
				
				gridOptions.columns = [{
						field: 'kpi',
						title: '目标',
					},
					{
						field: 'itemid',
						title: '商品编码',
					}, {
						field: 'date',
						title: '时间'
					},
					{
						field: '',
						title: '操作',
						width: 130,
						fixed: "right",
						align: 'center',
						slots: {
							default:({row})=>{
								return	[
										<el-button size="mini" type="text" style="color:#409EFF;" onClick={()=>{this.cleargroupkpi(row)}}>清空</el-button>,
										<el-button size="mini" type="text" style="color:#F56C6C;" onClick={()=>{this.deletegroupkpi(row)}}>删除</el-button>								
									]
							}
						}
					},
				]
				gridOptions.toolbarConfig.buttons = [{
					name: '添加',
					status: 'primary',
					code: 'add'
				},{
					name: '导入',
					status: 'success',
					code: 'importgoodskpi'
				}]
				gridOptions.formConfig = false
			},
			add(){
				this.$refs.addspukpiIndex.modal_show()
			},
			addHide() {
				this.$refs.groupkpiTable.commitProxy('query')
			},
			deletegroupkpi(row){
				this.$api.BIshopgoods.deletegroupkpi({
					id: row.id,
				}).then(() => {
					this.$refs.groupkpiTable.commitProxy('query')
				})
			},
			cleargroupkpi(row){
				this.$confirm('是否清空【' + row.date + '】所有数据').then(()=>{
					this.$api.BIshopgoods.cleargroupkpi({
						date: row.date,
						groupid: row.groupid,
					}).then(() => {
						this.$refs.groupkpiTable.commitProxy('query')
					})
				})

			},
			list() {
				return new Promise((resolve) => {
					this.$api.BIshopgoods.listgroupkpi({
						nodeid: this.nodeid,
						type:'spu'
					}).then((res) => {
						resolve({
							list: res
						})
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			addIndex,
			importTable
		}
	}
</script>